export const defaultState = {
  isAuthenticated: Boolean(localStorage.getItem("token")),
  isAuthenticating: false,
  isLoggingOut: false,
  isFetching: false,
  hasFailed: false,
  errorMsg: "",
  token: "",
};
